import { HttpClient } from '@angular/common/http';
import * as Routes from 'src/Routes';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MissionService {


  constructor(private http: HttpClient) { }

  async add(formData): Promise<any> {
    return await this.http.post(Routes.MISSION, formData).toPromise();
  }

  public async update(id: number, formData): Promise<any> {
    return await this.http
      .post(`${Routes.MISSION}/${id}`, formData)
      .toPromise();
  }

  public gets() {
    return this.http.get<any>(`${Routes.MISSION}`)
      .toPromise();
  }


  public async delete(id) {
    return await this.http
      .delete(`${Routes.MISSION}/${id}`)
      .toPromise();
  }

  find(id: number): Promise<any> {
    return this.http.get<any>(`${Routes.MISSION}/${id}`).toPromise();
  }

  async document(formData): Promise<any> {
    return await this.http.post(Routes.DOCUMENT_MISSION, formData).toPromise();
  }
    
}
